import { useState, useEffect, useCallback, useRef } from "react";
import api from "api/api";
import { useNavigate } from "react-router-dom";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components

// import mui icons
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

//import assets

//import component
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import Loader from "../components/common/Loader";
import MainNavigation from "../components/common/MainNavigation";
import FilterAcrossProductsToggleComponent from "../components/common/FilterAcrossProductsToggleComponent";
import PercentageToggleComponent from "../components/common/PercentageToggleComponent";
import OverallFragranceToggleComponent from "../components/common/OverallFragranceToggleComponent";
// import OverallToggleComponent from "../components/common/OverallToggleComponent";
import Reset from "../components/common/Reset";
import TTestDialog from "../components/common/TTest/TTestDialog";
import SignificanceToggleComponent from "components/common/SignificanceToggleComponent";

import ViewToggle from "../components/common/ViewToggle";
import FullScreenConatiner from "../components/layouts/FullScreenConatiner";
import InitialPopup from "../components/common/InitialPopup";
import AnalysisTableFragranceAssociation from "../components/clt/analysisModule/AnalysisTableFragranceAssociation";
import AnalysisChartFragranceAssociation from "../components/clt/chart/AnalysisChartFragranceAssociation";

//redux
import { useSelector, useDispatch } from "react-redux";
import {
    loadSignificanceToggleState,
    loadDisableSignificanceToggleState,
    loadFragranceAssociationResultState,
    loadIsFragranceMetricsAnalysisResultLoadingState,
    loadFragranceMetricsAnalysisResultState,
    loadDefaultFragranceMetricsAnalysisResultState,
    loadOverallFragranceToggleState,
} from "store/features/analysisResultsSlice";

import { resetTTestStore } from "store/features/ttestSlice";
import { loadAgreementRemovedKpiListState } from "store/features/analysisKpiSlice";
import { showNotification } from "store/features/notificationSlice";

// utils
import GetFragranceAssociationResult from "../utils/apis/GetFragranceAssociationResult";
import GetFragranceMetricsResult from "../utils/apis/GetFragranceMetricsResult";

function FragranceAssociationCLT({ headerTitle = "" }) {
    //REDUX
    const dispatch = useDispatch();
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);

    const productsSecondaryDataState = useSelector((state) => state.analysisResultsStore.fragranceMetricsAnalysisResult);
    const overallFragranceDataState = useSelector((state) => state.analysisResultsStore.fragranceAssociationResult);
    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);
    const isConsumerFilterSelected = useSelector((state) => state.consumerFilterStore.filterSelectionStatus);
    const overallToggle = useSelector((state) => state.analysisResultsStore.overallFragranceToggle || false);
    const percentageToggle = useSelector((state) => state.analysisResultsStore.percentageToggle);

    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;
    const [isTableShown, setIsTableShown] = useState(true);

    const [dataMappingData, setDataMappingData] = useState([]);
    const [fragranceAssociationDataMappingData, setFragranceAssociationDataMappingData] = useState([]);

    const [isDataMappingDataLoading, setIsDataMappingDataLoading] = useState(false);
    const [isFragranceAssociationDataMappingDataLoading, setIsFragranceAssociationDataMappingDataLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isFragranceAssociationLoading, setIsFragranceAssociationLoading] = useState(false);
    const navigate = useNavigate();
    const [isViewRendering, setIsViewRendering] = useState(false);

    // t-test details
    const [tTestResult, setTTestResult] = useState([]);
    const [testLabel, setTestLabel] = useState("");
    const [testLabel2, setTestLabel2] = useState("");

    // Analysis type
    const agreementBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisSelection);
    const analysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.fragranceAssociationAnalysisTypeValue);
    const boxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.fragranceAssociationBoxAnalysisTypeSelection);
    const [isFisher, setIsFisher] = useState(false);
    const [legends, setLegends] = useState([]);
    const [faLegends, setFaLegends] = useState([]);

    const [btnDisabled, setBtnDisabled] = useState({});

    const isOralCare = process.env?.REACT_APP_ORAL_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCleansing = process.env?.REACT_APP_SKIN_CLEANSING?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    const btnArr = isUnileverFragranceHouse ? ["fragranceMetricsAnalysisCLT", "agreementkpiClt"] : ["fragranceMetricsAnalysisCLT", "preferenceAnalysis", "agreementkpiClt", "productPreferenceAnalysis"];

    const [activeTab, setActiveTab] = useState("");
    const prevPercentageToggleRef = useRef();
    const [disableSignificance, setDisableSignificance] = useState(false);

    const clearResult = () => {
        setTTestResult([]);
        setTestLabel("");
        setTestLabel2("");
        setLegends([]);
        setFaLegends([]);
        dispatch(resetTTestStore());
    };

    const resetToggleStates = () => {
        dispatch(loadSignificanceToggleState(false));
        dispatch(loadDisableSignificanceToggleState(true));
        dispatch(loadOverallFragranceToggleState(true));
    };

    useEffect(() => {
        if (!isTableShown) {
            dispatch(loadSignificanceToggleState(false));
            dispatch(loadDisableSignificanceToggleState(true));
            setDisableSignificance(true);
        } else {
            if (overallToggle) {
                if (legends.length > 0 || faLegends.length > 0) {
                    dispatch(loadSignificanceToggleState(true));
                    dispatch(loadDisableSignificanceToggleState(false));
                    setDisableSignificance(false);
                } else {
                    dispatch(loadSignificanceToggleState(false));
                    dispatch(loadDisableSignificanceToggleState(true));
                    setDisableSignificance(true);
                }
            } else {
                if (faLegends.length > 0) {
                    dispatch(loadSignificanceToggleState(true));
                    dispatch(loadDisableSignificanceToggleState(false));
                    setDisableSignificance(false);
                } else {
                    dispatch(loadSignificanceToggleState(false));
                    dispatch(loadDisableSignificanceToggleState(true));
                    setDisableSignificance(true);
                }
            }
        }
    }, [overallToggle, isTableShown, legends, faLegends]);

    // clear T Test
    useEffect(() => {
        clearResult();
    }, [weightToggle]);

    useEffect(() => {
        const prevValue = prevPercentageToggleRef.current;
        if (prevValue !== undefined && prevValue !== percentageToggle) {
            clearResult();
        }
        prevPercentageToggleRef.current = percentageToggle;
    }, [percentageToggle, clearResult]);

    useEffect(() => {
        if (isOralCare || isSkinCleansing) {
            if (!isLoading) {
                if (!isConsumerFilterSelected) {
                    InitialPopup.general();
                }
            }
        }
    }, [isLoading, isOralCare, isConsumerFilterSelected, isSkinCleansing]);

    useEffect(() => {
        let _selectedStudies = selectedStudy;

        let disableBtn = _selectedStudies.length === 0;
        let tempObj = {
            fragranceMetricsAnalysisCLT: disableBtn,
            agreementkpiClt: disableBtn,
            preferenceAnalysis: disableBtn,
            productPreferenceAnalysis: disableBtn,
        };
        setBtnDisabled(tempObj);
    }, [selectedStudy]);

    const clearTtest = (product, type) => {
        // clear t test
        if (type === "consumerFilterAll") {
            clearResult();
        } else if (type === "consumerFilter") {
            const tTestPro = tTestResult?.[0]?.colors?.map((datum) => datum.productCode) || [];
            const cfPc = product?.split("_")?.join(" ") || "";
            if (tTestPro.indexOf(cfPc) !== -1) {
                clearResult();
            }
        }
    };

    const getFragranceResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], allAnalysisData = {} }) => {
        clearTtest(product, type);
        setIsLoading(true);
        setIsViewRendering(true);
        const fragranceAssociationResult = await GetFragranceAssociationResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, productsSecondaryDataState: allAnalysisData?.fragranceAssociationResult || [], productsOrder, productCategoryId });
        if (fragranceAssociationResult) {
            await dispatch(loadFragranceAssociationResultState([...fragranceAssociationResult]));
        }
        setIsLoading(false);
    };

    const getOverallResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], allAnalysisData = {}, fetchOnlyCurrent = false, boxAnalysisSelection = {} }) => {
        clearTtest(product, type);
        setIsFragranceAssociationLoading(true);
        setIsViewRendering(true);
        dispatch(loadIsFragranceMetricsAnalysisResultLoadingState(true));

        const fragranceMetricsResult = await GetFragranceMetricsResult({
            product,
            coreDataId,
            type,
            consumerFilter,
            pcs,
            selectedStudy,
            productsSecondaryDataState: allAnalysisData?.fragranceMetricsAnalysisResult || [],
            productsOrder,
            productCategoryId,
            boxAnalysisSelection: boxAnalysisSelection["fragranceOverall"] || {},
            studyTypeMethod: "clt",
        });
        if (fragranceMetricsResult) {
            await dispatch(loadFragranceMetricsAnalysisResultState([...fragranceMetricsResult]));
            if (!type) {
                dispatch(loadDefaultFragranceMetricsAnalysisResultState([...fragranceMetricsResult]));
            }
        }
        dispatch(loadIsFragranceMetricsAnalysisResultLoadingState(false));
        console.log("fetchOnlyCurrent", fetchOnlyCurrent);
        setIsFragranceAssociationLoading(false);
    };

    const handleFilter = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], allAnalysisData = {}, fetchOnlyCurrent = false, boxAnalysisSelection = {} }) => {
        getFragranceResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, allAnalysisData });
        getOverallResult({ product, coreDataId, type, consumerFilter, pcs, selectedStudy, allAnalysisData, fetchOnlyCurrent, boxAnalysisSelection });
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    useEffect(() => {
        async function fetchDataMappingData() {
            try {
                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/all/?archive=false&uniq=true&variable_category=${encodeURIComponent("Fragrance Metrics Analysis")}`;

                if (productCategoryId) {
                    url += `&product_category=${productCategoryId}`;
                }
                setIsDataMappingDataLoading(true);
                await api
                    .get(url)
                    .then(async (res) => {
                        setDataMappingData(res.data);
                        setIsDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsDataMappingDataLoading(false);
            }
        }

        async function fetchFragranceAssociationDataMappingData() {
            try {
                let url = process.env.REACT_APP_SERVER_PATH + `/data-mappings/all/?archive=false&uniq=true&variable_category=${encodeURIComponent("Fragrance Association")}`;

                if (productCategoryId) {
                    url += `&product_category=${productCategoryId}`;
                }
                setIsFragranceAssociationDataMappingDataLoading(true);
                await api
                    .get(url)
                    .then(async (res) => {
                        setFragranceAssociationDataMappingData(res.data);
                        setIsFragranceAssociationDataMappingDataLoading(false);
                    })
                    .catch((error) => {
                        handleError("error", error);
                        setIsFragranceAssociationDataMappingDataLoading(false);
                    });
            } catch (error) {
                handleError("error", error);
                setIsFragranceAssociationDataMappingDataLoading(false);
            }
        }

        async function fetchAnalysisResult() {
            if (!overallFragranceDataState.length) {
                setIsViewRendering(true);
                await getOverallResult({
                    product: null,
                    coreDataId: null,
                    type: null,
                    consumerFilter: null,
                    pcs: [],
                    selectedStudy,
                    allAnalysisData: [],
                    fetchOnlyCurrent: true,
                    productCategoryId: productCategoryId,
                });
            }
        }

        const fetchFragranceAssociationResult = async () => {
            if (!overallFragranceDataState.length) {
                setIsViewRendering(true);
                setIsLoading(true);
                const fragranceResult = await getFragranceResult({
                    product: null,
                    coreDataId: null,
                    type: null,
                    consumerFilter: null,
                    pcs: [],
                    selectedStudy,
                    allAnalysisData: [],
                    fetchOnlyCurrent: true,
                    productCategoryId: productCategoryId,
                });
                if (fragranceResult) {
                    await dispatch(loadFragranceAssociationResultState([...fragranceResult]));
                }
                setIsLoading(false);
            }
        };

        if (selectedStudy.length === 0) {
            navigate("/studies");
        } else {
            fetchAnalysisResult();
            fetchFragranceAssociationResult();
            fetchDataMappingData();
            fetchFragranceAssociationDataMappingData();
        }
    }, [selectedStudy, productsSecondaryDataState, productCategoryId, navigate]);

    useEffect(() => {
        return () => {
            dispatch(loadAgreementRemovedKpiListState([]));
        };
    }, [dispatch]);
    const handleViewRenderComplete = useCallback(() => {
        setIsViewRendering(false);
    }, []);

    const handleViewToggle = (newIsTableShownValue) => {
        if (isTableShown === newIsTableShownValue) return;
        setIsViewRendering(true);
        setIsTableShown(newIsTableShownValue);
    };

    return (
        <>
            {(isLoading || isDataMappingDataLoading || isFragranceAssociationLoading || isFragranceAssociationDataMappingDataLoading || isViewRendering) && <Loader />}
            <Header
                title={headerTitle}
                isStudySelected={true}
            />
            <div
                className="ms-4 me-4 mb-0 mt-3 background-color-white box-shadow--2 d-flex"
                style={{
                    borderRadius: "5px",
                }}
            >
                <FiltersHeaderLabel multipleLabel={true} />
            </div>
            <FullScreenConatiner>
                <div
                    className=""
                    style={{
                        width: 150,
                        display: "flex",
                        alignItems: "center",
                        position: "absolute",
                        zIndex: 1,
                    }}
                >
                    <div
                        className="p-2 liner-light-blue-background color-white"
                        style={{
                            borderRadius: "50%",
                            position: "relative",
                            top: -15,
                            left: -15,
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            if (window.history.length > 1) {
                                navigate(-1);
                            } else {
                                navigate("/studies");
                            }
                        }}
                    >
                        <span>
                            <ArrowBackIcon className="color-white" />
                        </span>
                    </div>
                </div>

                <div
                    className="card-btns"
                    style={{ padding: "20px 20px 20px 20px" }}
                >
                    <div
                        style={{
                            display: "flex",
                            zIndex: 9,
                        }}
                    >
                        <ViewToggle
                            value={isTableShown}
                            setValue={handleViewToggle}
                            labels={["Table", "Chart"]}
                        />

                        <div
                            style={{
                                marginLeft: "1.5rem",
                                width: "170px",
                            }}
                        >
                            <PercentageToggleComponent />
                        </div>
                        <div
                            style={{
                                marginLeft: "1.5rem",
                                width: "220px",
                            }}
                        >
                            <OverallFragranceToggleComponent />
                        </div>
                    </div>

                    <div>
                        <SignificanceToggleComponent disabled={disableSignificance} />
                        <FilterAcrossProductsToggleComponent />
                        <TTestDialog
                            isFragranceAssociationSection={true}
                            overallToggleEnabled={overallToggle}
                            percentageToggle={percentageToggle}
                            variableCategory="Fragrance Association"
                            functionsSettings={{
                                setIsFisher: setIsFisher,
                                setLegends: setLegends,
                                setFaLegends: setFaLegends,
                                setTTestResult: setTTestResult,
                                setTestLabel: setTestLabel,
                                setTestLabel2: setTestLabel2,
                                clearResult: clearResult,
                            }}
                            analysisLevelData={{
                                moduleName: "fragranceAssociation",
                                analysisTypeValue: analysisTypeValue,
                                boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                boxAnalysisSelection: agreementBoxAnalysisSelection,
                                mappings: dataMappingData.length !== 0 && dataMappingData.columns.filter((ele) => ele.macroCategory.toLowerCase().includes("overall")),
                                fragranceAssociationMappings: fragranceAssociationDataMappingData.columns,
                            }}
                            tabData={{
                                productsSecondaryDataState: productsSecondaryDataState,
                                fragranceAssociationDataState: overallFragranceDataState
                            }}
                        />
                        <Reset
                            clearTTestResult={() => {
                                clearResult();
                                resetToggleStates();
                            }}
                        />
                    </div>
                </div>
                {productsSecondaryDataState.length !== 0 && dataMappingData.length !== 0 && (
                    <div
                        style={{
                            minHeight: "calc(100vh - 300px)",
                            padding: "20px",
                        }}
                    >
                        {isTableShown ? (
                            <AnalysisTableFragranceAssociation
                                productsSecondaryData={overallFragranceDataState}
                                handleFilterSubmit={handleFilter}
                                selectedStudy={selectedStudy}
                                analysisLevelData={{
                                    tableConfig: {
                                        stickyColumns: [""],
                                    },
                                    moduleName: "fragranceAssociation",
                                    analysisTypeValue: analysisTypeValue,
                                    // boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    // boxAnalysisSelection: agreementBoxAnalysisSelection,
                                    mappings: fragranceAssociationDataMappingData.columns,
                                    overallFragrance: productsSecondaryDataState,
                                    fragranceAssociationMappings: dataMappingData.columns.filter((ele) => ele.macroCategory.toLowerCase().includes("overall")),
                                }}
                                tTest={{
                                    tTestLegends: legends,
                                    tTestFaLegends: faLegends,
                                    isFisher: isFisher,
                                    tTestResult: tTestResult,
                                    testLabel: testLabel,
                                    testLabel2: testLabel2,
                                }}
                                settings={{
                                    activeTab: activeTab,
                                    setActiveTab: setActiveTab,
                                }}
                                onRenderComplete={handleViewRenderComplete}
                            />
                        ) : (
                            <AnalysisChartFragranceAssociation
                                productsSecondaryData={overallFragranceDataState}
                                handleFilterSubmit={handleFilter}
                                selectedStudy={selectedStudy}
                                analysisLevelData={{
                                    tableConfig: {
                                        stickyColumns: [""],
                                    },
                                    moduleName: "fragranceAssociation",
                                    analysisTypeValue: analysisTypeValue,
                                    // boxAnalysisTypeSelection: boxAnalysisTypeSelection,
                                    // boxAnalysisSelection: agreementBoxAnalysisSelection,
                                    mappings: fragranceAssociationDataMappingData.columns,
                                    overallFragrance: productsSecondaryDataState,
                                    fragranceAssociationMappings: dataMappingData.columns.filter((ele) => ele.macroCategory.toLowerCase().includes("overall")),
                                }}
                                tTest={{
                                    tTestLegends: legends,
                                    isFisher: isFisher,
                                    tTestResult: tTestResult,
                                    testLabel: testLabel,
                                    testLabel2: testLabel2,
                                }}
                                settings={{
                                    activeTab: activeTab,
                                    setActiveTab: setActiveTab,
                                }}
                                onRenderComplete={handleViewRenderComplete}
                            />
                        )}
                    </div>
                )}
                <div
                    style={{
                        position: "relative",
                        top: "5px",
                        marginTop: "30px",
                    }}
                >
                    <MainNavigation
                        buttons={btnArr}
                        isFragrance={true}
                        btnDisabledObj={btnDisabled}
                    />
                </div>
            </FullScreenConatiner>
        </>
    );
}

// Typechecking props for the AgreementKpi
FragranceAssociationCLT.propTypes = {
    headerTitle: PropTypes.string,
};

export default FragranceAssociationCLT;
